<div class="dark-mode">
    <div class="row my-3">
        <div class="col-12 col-sm-12 col-md-6">
            <h4 class="mt-3">Continuing Education Units (CEUs)</h4>
            <div style="color: #979797">Track and manage your CEUs to advance your professional skills</div>
        </div>

        <div class="col-12 col-sm-12 col-md-6 text-end d-flex justify-content-end">
            <button (click)="getTranscript()" class="mt-3" style="margin-right: 5px;" mat-raised-button aria-label="request pdf transcript" color="warn">
                <mat-icon>picture_as_pdf</mat-icon> Transcript
            </button>
            <button (click)="openModalAddCeuCredit()" class="mt-3 bg-accent-orange" mat-raised-button aria-label="add certification" >
                <mat-icon>add</mat-icon> Upload
            </button>

        </div>
    </div>
    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap">Certification</th>
                <th class="text-nowrap">Document Type</th>
                <th class="text-nowrap">File</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let cert of userCEUs">
                <td class="ellipsis">{{cert.certificationTitle}}</td>
                <td>{{maskingColumn('parameterLabel', 'parameterValue', docTypes.parameterMembers, cert.documentType)}}</td>
                <td>{{cert.fileName}}</td>
                <td class="sticky-action" style="width: 180px;">
                    <div class="d-flex gap-4 justify-content-center">
                        <mat-icon class="text-white" (click)="viewCert(cert)">arrow_forward</mat-icon>
                        <mat-icon class="accent-green" (click)="downloadCert(cert)">download</mat-icon>
                        <mat-icon class="accent-orange" (click)="editCert(cert)">edit</mat-icon>
                        <mat-icon class="crimson-red" (click)="deleteCert(cert)">delete</mat-icon>
                    </div>
                </td>
            </tr>
            <tr *ngIf="!populate && userCEUs.length == 0">
                <td colspan="7" class="text-center">
                    <span>No CEU available </span>
                </td>
            </tr>
            <tr *ngIf="populate">
                <td colspan="7" class="text-center">
                    <span>Populate data... please wait</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="mt-4" *ngIf="userCEUs.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>

